/**
 * singleProductGenerator - Generates a single product object from the given product object and store code.
 * @name singleProductGenerator
 * @function
 * @param productObject - The product object containing product data.
 * @param storeCode - The store code to filter the product data.
 * @returns {object} - The generated product object with routeParam and product data.
 */
export function singleProductGenerator(productObject, storeCode) {
  if (productObject && productObject.data) {
    if (!productObject.data.product || !productObject.data.product[storeCode]) {
      throw new Error(`Product '${productObject.data.uid}' not found in store '${storeCode}'. This may be because the associated 'Product' is missing in the 'Product Header' Slice.`)
    }
    return { routeParam: productObject.data.uid, ...productObject.data.product[storeCode] }
  }
}

/**
 * productsGenerator - Generates an array of product objects from the given item and suffix.
 * @name productsGenerator
 * @function
 * @param item - The item object containing product data.
 * @param suffix - An array of suffixes to filter the product data.
 * @param storeCode - The store code to filter the product data.
 * @returns {array} - An array of generated product objects.
 */
export function productsGenerator(item, suffix, storeCode) {
  const products = []
  suffix.forEach((s) => {
    const singleProduct = singleProductGenerator(item[`block_product_${s}`], storeCode)
    if (singleProduct) {
      products.push(singleProduct)
    }
  })
  return products.filter(x => x)
}
